import React from 'react';
import { X, Save, RefreshCw } from 'lucide-react';
import DotCheckbox from './DotCheckbox';

const AssignAdminModal = ({
  theme,
  styles,
  selectedCompany,
  adminCandidates,
  selectedAdminIds,
  adminSearch,
  loadingAdmins,
  setAdminSearch,
  onToggleAdmin,
  onSave,
  onClose,
}) => {
  return (
    <div style={styles.modal} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>Assign Admins - {selectedCompany}</h3>
          <button style={styles.closeButton} onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <input
          type="text"
          value={adminSearch}
          onChange={(e) => setAdminSearch(e.target.value)}
          placeholder="Search employees by name..."
          style={styles.input}
        />

        {loadingAdmins ? (
          <div style={{
            textAlign: "center",
            padding: "40px",
            color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
          }}>
            <RefreshCw size={32} style={{ animation: 'spin 1s linear infinite', marginBottom: '12px' }} />
            <p>Loading employees...</p>
          </div>
        ) : (
          <div style={{
            maxHeight: "50vh",
            overflowY: "auto",
            padding: "16px",
            background: theme === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            marginBottom: "20px",
          }}>
            {adminCandidates
              .filter(emp => !adminSearch || emp.sr.toLowerCase().includes(adminSearch.toLowerCase()))
              .map(emp => (
                <label
                  key={emp.infinityCode}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "10px 12px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) =>
                    e.currentTarget.style.background =
                      theme === "dark" ? "rgba(148,163,184,0.08)" : "rgba(15,23,42,0.03)"
                  }
                  onMouseLeave={(e) =>
                    e.currentTarget.style.background = "transparent"
                  }
                >
                  <DotCheckbox
                    checked={selectedAdminIds.includes(emp.infinityCode)}
                    onChange={() => onToggleAdmin(emp.infinityCode)}
                    theme={theme}
                  />
                  <span style={{ fontSize: "14px", color: theme === "light" ? "#0f172a" : "#ffffff" }}>
                    {emp.sr}
                  </span>
                </label>
              ))}

            {adminCandidates.filter(emp =>
              !adminSearch || emp.sr.toLowerCase().includes(adminSearch.toLowerCase())
            ).length === 0 && (
              <p style={{
                textAlign: "center",
                color: theme === "light" ? "#64748b" : "rgba(255, 255, 255, 0.6)",
              }}>
                No employees found
              </p>
            )}
          </div>
        )}

        <div style={styles.modalButtons}>
          <button style={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button
            style={styles.submitButton}
            onClick={() => onSave(selectedCompany)}
            disabled={loadingAdmins || selectedAdminIds.length === 0}
          >
            {loadingAdmins ? (
              <>
                <RefreshCw size={16} style={{ animation: 'spin 1s linear infinite' }} />
                Saving...
              </>
            ) : (
              <>
                <Save size={16} />
                Assign Admins ({selectedAdminIds.length})
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignAdminModal;